<template>
  <div class="component-container">

    <div class="loading" v-if="performingRequest">
      <p>Loading...</p>
    </div>
    <div class="units-grid">
      <template v-for="unit in allUnits">
        <div class="unit-display" :key="unit.unitId" v-if="unit.purchased">
          <a @click.prevent="setDashboardView(unit.unitId)"><img :src="require(`../../assets/units/${unit.unitId}_Cover.jpg`)" alt="" v-if="unit.purchased" class="responsive"></a>
          <a @click.prevent="setDashboardView(unit.unitId)" v-if="unit.purchased"><h3>{{unit.unitId}} - {{unit.unitTitle}}</h3></a>
        </div>
      </template>
    </div>
    <!-- <table>
      <tr v-for="unit in allUnits" :key="unit.unitId">
        <td v-if="unit.purchased"><a @click.prevent="setDashboardView(unit.unitId)">{{unit.unitId}} - {{unit.unitTitle}}</a></td>
      </tr>
    </table> -->
    <p>Additional titles are available for purchase. Please visit our <a href="https://cerealcityscience.org" target="_blank">main website</a> or contact Suzan Luther at suzan@bcamsc.org or (269) 213-3904 for more information.</p>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebase')
import { mapState } from 'vuex'

export default {
  data() {
    return {
      availableUnits: [],
      allUnits: [],
      performingRequest: false
    }
  },
  computed: {
    ...mapState([ 'userProfile' ])
  },
  methods: {
    fetchAvailableUnits() {
      this.performingRequest = true
      setTimeout(() => {
        fb.districtsCollection.doc(this.userProfile.districtId).get().then((doc) => {
          if (doc.exists) {
            // console.log(doc.data().units)
            this.availableUnits = doc.data().units
            // console.log(this.availableUnits)
          } else {
            console.log('no doc')
          }
        }).then(() => {
          this.fetchAllUnits()
        }).catch((err) => {
          console.log(err)
        })
      }, 1500)
    },
    fetchAllUnits() {
      fb.unitsCollection.orderBy('orderBy').get().then((snap) => {
        snap.forEach((doc) => {
          this.allUnits.push(doc.data())
          // console.log(this.allUnits)
        })
      }).then(() => {
        this.updateAllUnits()
      }).catch((err) => {
        console.log(err)
      })
    },
    updateAllUnits() {
      console.log('updating')
      setTimeout(() => {
        this.allUnits.forEach((element) => {
          if (this.availableUnits.includes(element.unitId)) {
            element.purchased = true
            // console.log(element.unitId)
          }
        })
      }, 1500)

      this.performingRequest = false
    },
    setDashboardView(unit) {
      this.$store.commit('SET_DASHBOARD_VIEW', unit)
    }
  },
  mounted() {
    this.fetchAvailableUnits()
  }
}
</script>

<style lang="css" scoped>
table {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #cecece;
}
th, td {
  padding: 15px;
  border-top: 1px solid #cecece;
}
th {
  background: #0e314d;
  color: white;
  font-weight: 600;
  font-size: 1.2em
}
tr:nth-child(even) {
  background: #f7f7f7;
}
.units-grid{
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 40px;
}
.unit-display {
  border: 1px solid #cecece;
  border-radius: 5px;
  overflow: hidden;
}
.unit-display h3 {
  padding: 5px;
}
</style>
